module.exports = __webpack_public_path__ + "static/media/emailupload.682260ad.png";